import { render } from "./SongLibraryView.vue?vue&type=template&id=4e5936e0&scoped=true"
import script from "./SongLibraryView.vue?vue&type=script&lang=js"
export * from "./SongLibraryView.vue?vue&type=script&lang=js"

import "./SongLibraryView.vue?vue&type=style&index=0&id=4e5936e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5936e0"]])

export default __exports__